import { Package } from '@frontend/icons';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { useEquipmentReturnLost } from './equipment-return-lost.controller';

const ID = 'equipment-return-lost';

export const EquipmentReturnLost = () => {
    const viewProps = useEquipmentReturnLost();

    return (
        <WizardScreenContainer
            id={ID}
            footer={{
                onBack: viewProps.onBack,
                onSubmit: viewProps.onSubmit,
                submitDisabled: viewProps.submitDisabled
            }}
            loadingModal={{ show: viewProps.isBusy }}
            errorModal={{
                show: !!viewProps.error,
                title: (
                    <FormattedMessage
                        id='kiosk.wizard.equipment-return-lost.error-title'
                        defaultMessage='Return error'
                    />
                ),
                message: viewProps.error,
                onClose: viewProps.resetError
            }}
            containerClassName='bg-background-default flex flex-1 flex-col items-start justify-start gap-2 self-stretch overflow-y-scroll p-0'>
            <div className='flex flex-1 flex-col items-start justify-start gap-4 self-stretch px-5 pt-6 pb-20'>
                <div className='mb-2 flex items-start justify-start self-stretch'>
                    <div className='text-foreground-default justify-start text-base font-medium'>
                        <FormattedMessage
                            id='kiosk.wizard.equipment-return-lost.instructions'
                            defaultMessage='You are returning an item that was previously marked as lost. Confirm to drop it off.'
                        />
                    </div>
                </div>

                {viewProps.configError && (
                    <div className='bg-background-surface inline-flex items-center justify-start self-stretch rounded-xl p-4'>
                        <div className='text-status-danger justify-start text-base font-medium'>
                            <FormattedMessage
                                id='kiosk.wizard.equipment-return-lost.config-error'
                                defaultMessage='This distriSPOT is not configured for returns. Please contact support.'
                            />
                        </div>
                    </div>
                )}

                {viewProps.loadError && !viewProps.isLoading && (
                    <div className='bg-background-surface inline-flex items-center justify-between gap-4 self-stretch rounded-xl p-4'>
                        <div className='text-status-danger justify-start text-base font-medium'>
                            <FormattedMessage
                                id='kiosk.wizard.equipment-return-lost.load-error'
                                defaultMessage='We could not load the product details. Please try again.'
                            />
                        </div>
                        <button
                            type='button'
                            className='text-brand-default text-sm font-medium'
                            onClick={viewProps.retryLoad}>
                            <FormattedMessage
                                id='kiosk.wizard.equipment-return-lost.retry'
                                defaultMessage='Retry'
                            />
                        </button>
                    </div>
                )}

                {viewProps.equipment && !viewProps.isLoading && (
                    <div className='bg-background-surface inline-flex items-center justify-start gap-4 self-stretch rounded-xl p-4'>
                        <div className='outline-border-default relative flex size-12 items-center justify-center rounded-full outline-2'>
                            <Package className='size-1/2' />
                        </div>
                        <div className='inline-flex flex-col items-start justify-center gap-1'>
                            <div className='text-foreground-default justify-start text-base font-semibold'>
                                {viewProps.product?.name ?? (
                                    <FormattedMessage
                                        id='kiosk.wizard.equipment-return-lost.unknown-product'
                                        defaultMessage='Unknown product'
                                    />
                                )}
                            </div>
                            <div className='text-brand-muted justify-start text-base font-medium'>{viewProps.equipment.serial_number}</div>
                        </div>
                    </div>
                )}
            </div>
        </WizardScreenContainer>
    );
};

export default EquipmentReturnLost;
